import axios from 'axios';
import Identity from '../../config/mocks/identity';

// axios.create({ withCredentials: true });

const etfService = {};

etfService.Documento = () => axios.get(`/Documento/`,{
	params: {
		ID: Identity.ID()
	},
});

etfService.Geral = () => axios.get(`/Geral/`,{
	params: {
		ID: Identity.ID()
	},
});

etfService.Caracteristicas = () => axios.get('/Caracteristica/',{
	params: {
		ID: Identity.ID()
	},
});

etfService.Rentabilidade = (year, month) =>
	axios.get(`/Rentabilidade/`, {
		params: {
			ano: year,
			mes: month,
			ID: Identity.ID()
		},
	});

etfService.RentabilidadeAcumulada = (beginDate, endDate, periodParam) =>
	axios.get('/Rentabilidade/GetAcumulado/', {
		params: {
			datainicio: beginDate,
			datafim: endDate,
			seisMesesUmanoDoInicio: periodParam,
			ID: Identity.ID()
		},
	});

etfService.RentabilidadeMensal = (year, month) =>
	axios.get(`/Rentabilidade/GetRentabilidadeMensal/`, {
		params: {
			ano: year,
			mes: month,
			ID: Identity.ID()
		},
	});

etfService.RentabilidadeVolume = (year, month) =>
	axios.get(`/Rentabilidade/GetVolume/`, {
		params: {
			ano: year,
			mes: month,
			ID: Identity.ID()
		},
	});

etfService.RentabilidadeEvolucao = (year, month) =>
	axios.get(`/Rentabilidade/GetEvolucaoDiaria/`, {
		params: {
			ano: year,
			mes: month,
			ID: Identity.ID()
		},
	});

etfService.Cotista = () => axios.get('/Cotista/',{
	params: {
		ID: Identity.ID()
	},
});

etfService.MaioresCotistas = () => axios.get('/Cotista/MaioresCotistas',{
	params: {
		ID: Identity.ID()
	},
});

etfService.SegmentacaoCotistas = () => axios.get('/Cotista/SegmentacaoCotistas',{
	params: {
		ID: Identity.ID()
	},
});

etfService.MaioresMovimentacoes = () => axios.get('/Cotista/MaioresMovimentacoes',{
	params: {
		ID: Identity.ID()
	},
});

	//NOVOS ENDPOINTS

	//COMPOSICAO

etfService.CestaIntegralizacao = () => axios.get('/Composicao/CestaIntegralizacao',{
	params: {
		ID: Identity.ID()
	},
});

etfService.CestaResgate = () => axios.get('/Composicao/CestaResgate',{
	params: {
		ID: Identity.ID()
	},
});

etfService.Carteira = () => axios.get('/Composicao/Carteira',{
	params: {
		ID: Identity.ID()
	},
});

etfService.Emprestimo = () => axios.get('/Composicao/Emprestimo',{
	params: {
		ID: Identity.ID()
	},
});

etfService.Indice = () => axios.get('/Composicao/Indice',{
	params: {
		ID: Identity.ID()
	},
});

etfService.DatesAtualizacaoComposicao = () => axios.get('/Composicao/DatasAtualizacao',{
	params: {
		ID: Identity.ID()
	},
});

	//RENTABILIDADE

etfService.DatesAtualizacaoRentabilidade = () => axios.get('/Rentabilidade/DatasAtualizacao',{
	params: {
		ID: Identity.ID()
	},
});

etfService.AnosReferenciaRentabilidade = () => axios.get('/Rentabilidade/AnosReferencia',{
	params: {
		ID: Identity.ID()
	},
});


	//COTISTAS

etfService.DatesAtualizacaoCotistas = () => axios.get('/Cotista/DatasAtualizacao',{
	params: {
		ID: Identity.ID()
	},
});

	//FIM NOVOS ENDPOINTS


etfService.Composicao = () => axios.get('/Composicao',{
	params: {
		ID: Identity.ID()
	},
});

export { etfService };
